import React from 'react';
import styles from './Analytics.module.css';
import ListPicker from '../Shared/ListPicker';
import DateTimePicker from './DateTimePicker';
import { SENSORS } from '../../config';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function GraphOptions({
  selectedSystem,
  setSelectedSystem,
  detailLevel,
  setDetailLevel,
  onApplyClicked,
  fromDateTime,
  setFromDateTime,
  toDateTime,
  setToDateTime,
  selectedSensor,
  setSelectedSensor
}) {
  const { t } = useTranslation();
  const systems = useSelector((state) => state.bessReducer.overview.systems);
  let selectedSystemDetails = useSelector(
    (state) => state.bessReducer.details[selectedSystem.id]
  );
  const systemNames = systems.map((system) => system.name);

  // Add all detail-levels
  const detailOptions = ['System'];
  if (selectedSystemDetails.cabinets[0].sensors.length > 0) {
    detailOptions.push('Cabinet');
  }
  if (selectedSystemDetails.cabinets[0].modules[0].sensors > 0) {
    detailOptions.push('Module');
  }
  detailOptions.push('Cell');

  // Add all possible sensors
  const sensors = [];
  if (detailLevel === 'System') {
    sensors.push(
      ...selectedSystemDetails.sensors
        .filter((sensor) =>
          Object.keys(SENSORS).includes(sensor.sensorTypeName)
        )
        .map((sensor) => SENSORS[sensor.sensorTypeName])
    );
  } else if (detailLevel === 'Cell') {
    sensors.push(SENSORS.Voltage, SENSORS.InternalResistance);
  }
  const sensorNames = sensors.map((sensor) => sensor.name);
  const setSelectedSensorFromName = (name) => {
    setSelectedSensor(sensors.find((sensor) => sensor.name === name));
  };

  return (
    <div className={styles.optionsContainer}>
      <div>
        <ListPicker
          options={systemNames}
          selected={selectedSystem.name}
          setSelected={(newlySelected) => {
            setSelectedSystem(
              systems.find((system) => system.name === newlySelected)
            );
          }}
        />
        <DateTimePicker dateTime={fromDateTime} setDateTime={setFromDateTime} />
        <DateTimePicker dateTime={toDateTime} setDateTime={setToDateTime} />
        <div className={styles.optionsRow}>
          <ListPicker
            options={detailOptions}
            selected={detailLevel}
            setSelected={setDetailLevel}
          />
          <ListPicker
            options={sensorNames}
            selected={selectedSensor.name}
            setSelected={setSelectedSensorFromName}
          />
        </div>
      </div>
      <button className={styles.applyButton} onClick={onApplyClicked}>
        {t('apply')}
      </button>
    </div>
  );
}

export default GraphOptions;
